import { useQuery } from '@tanstack/react-query';
import { walletApi } from '@/api/wallet-api';

const WALLET_KEY = 'wallet';

export function useWithdrawals(page = 1, limit = 20) {
  return useQuery({
    queryKey: [WALLET_KEY, 'withdrawals', page, limit],
    queryFn: () => walletApi.getWithdrawals(page, limit),
    staleTime: 1000 * 60 * 1,
    gcTime: 1000 * 60 * 5,
    retry: 2,
  });
}
